var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettingsTwoKnobs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 12,
  viewBox: "0 0 18 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 6c1.302 0 2.401.839 2.815 2H17a1 1 0 1 1 0 2h-2.185A2.995 2.995 0 0 1 12 12a2.995 2.995 0 0 1-2.815-2H1a1 1 0 1 1 0-2h8.185A2.995 2.995 0 0 1 12 6m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 0c1.302 0 2.401.839 2.815 2H17a1 1 0 1 1 0 2H8.815A2.995 2.995 0 0 1 6 6a2.995 2.995 0 0 1-2.815-2H1a1 1 0 1 1 0-2h2.185A2.995 2.995 0 0 1 6 0m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
})));
export default SvgSettingsTwoKnobs;